import { z } from 'zod';

export const websiteDiscoverySchema = z.discriminatedUnion('method', [
  z.object({
    method: z.literal('quick'),
    limit: z.number().int().min(1).max(100000).default(5000),
    includePaths: z.array(z.string().max(2000)).max(100).default([]),
    excludePaths: z.array(z.string().max(2000)).max(100).default([]),
  }),
  ...(['listing', 'crawl'] as const).map(method =>
    z.object({
      method: z.literal(method),
      maxDepth: z.number().int().min(0).max(100).default(5),
      limit: z.number().int().min(1).max(10000).default(200),
      includePaths: z.array(z.string().max(2000)).max(100).default([]),
      excludePaths: z.array(z.string().max(2000)).max(100).default([]),
    }),
  ),
  z.object({ method: z.literal('single') }),
]);

export type WebsiteDiscoveryConfig = z.infer<typeof websiteDiscoverySchema>;

export const discoverWebsiteSchema = z.object({
  url: z.string().url(),
  discovery: websiteDiscoverySchema,
});
